import {
	NgModule,
	CUSTOM_ELEMENTS_SCHEMA,
	ModuleWithProviders,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FnCookieService } from './services/fn-cookies.service';
import { FnApplicationHelper } from './services/fn-application.helper';
import { FnApplication } from './services/fn-application';
import { FnUtilService } from './services/fn-util.service';
import { FnExceptionService } from './exception/fn-exception.service';
import { FNErrorLogSvcs } from './exception/fn-error.log.svcs';
import { FNErrorHandler } from './exception/fn-error.handler';
import { FnThemeService } from './services/fn-theme-service';
import { FnHttpService } from './services/fn-http.service';
import { FnAppSessionService } from './session/fn-app-session.service';
import { FnLocalStorageService } from './services/fn-local-storage.service';
import { FnScriptLoaderService } from './services/fn-script-loader.service';
import { FnCsvService } from './services/fn-csv.service';
import { FnFileService } from './services/fn-file.service';

const fnProviders = [
	FnApplicationHelper,
	FnApplication,
	FnUtilService,
	FnCookieService,
	FnExceptionService,
	FNErrorLogSvcs,
	FNErrorHandler,
	FnThemeService,
	FnHttpService,
	FnLocalStorageService,
	FnAppSessionService,
	FnScriptLoaderService,
	FnCsvService,
	FnFileService
];

@NgModule({
	declarations: [],
	imports: [FormsModule, CommonModule],
	exports: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	providers: [fnProviders],
})
export class FoundationModule {
	static forRoot(): ModuleWithProviders<FoundationModule> {
		return {
			ngModule: FoundationModule,
			providers: [fnProviders],
		};
	}
}
